import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import "./DeleteHobby.css";

function DeleteHobby() {
  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState();

  let { hid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/hobbies/${hid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setTitle(response.data.hobby.title);
      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/hobbies/${hid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/hobbies");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="delete-hobby">
            <Col>
              <h4>{t("Hobbies.Hobby.DeleteHobby.Titulo")}</h4>
            </Col>
            <Col className="delete-hobby-form">
              <Col className="mb-1">
                <p>{t("Hobbies.Hobby.DeleteHobby.Pregunta")}</p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Hobbies.Hobby.DeleteHobby.Eliminar")}
                </Button>
                <Button className="danger" onClick={() => navigate("/hobbies")}>
                  {t("Hobbies.Hobby.DeleteHobby.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteHobby;
